import { render } from "./AppInvoiceItem.vue?vue&type=template&id=4b255ff0&scoped=true&lang=pug"
import script from "./AppInvoiceItem.vue?vue&type=script&lang=js"
export * from "./AppInvoiceItem.vue?vue&type=script&lang=js"

import "./AppInvoiceItem.vue?vue&type=style&index=0&id=4b255ff0&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b255ff0"]])

export default __exports__